import { StyleSheet } from 'react-native';
import { pt, px } from '../common/utils';

export default StyleSheet.create({
    search_container: {
        flex: 1
    },
    search_wrap: {
        height: pt(50),
        backgroundColor: '#fff',
        paddingHorizontal: pt(10),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottomWidth: px(1),
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    search: {
        width: pt(315),
        height: pt(36),
        backgroundColor: '#F1F3F5',
        borderRadius: pt(18),
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: pt(2)
    },
    search_img: {
        width: pt(16),
        height: pt(15),
        marginLeft: pt(9),
        marginRight: pt(7)
    },
    input: {
        flex: 1,
        height: pt(36),
        padding: 0,
        fontSize: pt(14),
        color: '#252525',
	      width: pt(315 * 0.85),
    },
    close: {
        padding: pt(5)
    },
    close_icon: {
        width: pt(14),
        height: pt(14)
    },
    cancel: {
        color: '#252525',
        fontSize: pt(14)
    },
    main: {
        flex: 1
    },
    movie_title: {
        backgroundColor: '#fff',
        paddingLeft: pt(10)
    },
    title: {
        fontSize: pt(12),
        fontWeight: 'bold',
        color: '#666666',
        paddingTop: pt(10)
    },
    common_container: {
        // paddingHorizontal: pt(10),
        paddingLeft: pt(15),
        paddingRight: pt(10),
        backgroundColor: '#fff'
    },
    common_wrap: {
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomWidth: px(1),
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    history_word_wrap: {
        height: pt(50)
    },
    history_word: {
        fontSize: pt(14),
        color: '#252525',
        marginRight: pt(10)
    },
    history_remove: {
        padding: pt(10)
    },
    cinema_item_wrap: {
        paddingVertical: pt(12),
        borderBottomWidth: px(1),
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    cinema_name_price_wrap: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: pt(7)
    },
    cinema_name: {
        fontSize: pt(14),
        color: '#252525',
        // fontWeight: 'bold',
        marginRight: pt(8)
    },
    cinema_price: {
        fontSize: pt(18),
        color: '#E2231A'
        // fontWeight: 'bold'
    },
    cinema_address_wrap: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    cinema_address: {
        fontSize: pt(12),
        color: '#898989',
        width: pt(270)
    },
    cinema_distance: {
        fontSize: pt(12),
        color: '#898989'
    },
    cinema_km: {
        fontSize: pt(13),
        color: '#898989'
    },
    see_more_movie_wrap: {
        backgroundColor: '#fff',
        paddingHorizontal: pt(10),
        marginTop: -1
    },
    see_more_common: {
        height: pt(32),
        borderRadius: pt(5),
        backgroundColor: 'rgba(0,0,0,0.04)',
        alignItems: 'center',
        justifyContent: 'center'
    },
    see_more_wrap: {
        backgroundColor: '#fff',
        marginBottom: pt(15),
        marginTop: -1
    },
    see_more: {
        fontSize: pt(14),
        color: '#666666'
    },
    no_result_wrap: {
        backgroundColor: '#fff',
        paddingHorizontal: pt(10),
        height: pt(45),
        marginBottom: 10
    },
    no_result: {
        flex: 1,
        justifyContent: 'center'
    },
    no_result_text: {
        color: '#252525',
        fontSize: pt(14)
    }
});
